/**
 * Dynamic query for marketplace_categories with filtering support
 */
const categoriesQuery = `
query MarketplaceCategories($first: Int!, $skip: Int, $where: Marketplace_categoryWhereInput, $order: [Marketplace_categoryOrder!]) {
  marketplace_categories(
    first: $first,
    skip: $skip,
    where: $where,
    order: $order
  ) {
    count
    edges {
      node {
        objectId
        name
        b2b
        b2c
        icon {
          name
          url
        }
        cover {
          name
          url
        }
        createdAt
        updatedAt
      }
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default categoriesQuery;
